import React from "react";
import { useEffect } from "react";
import { Provider, useDispatch, useSelector } from "react-redux";
import Pagination from "../../../../components/Pagination/Pagination";
import StoreHelper from "../../../../services/store-helper";
import Detail from "./component/Detail";
import HeaderTabel from "./component/HeaderTabel";
import Tabel from "./component/Tabel";
import Total from "./component/Total";
import Action from "./redux/Action";
import reducerSlice from "./redux/Reducer";

const RequestMerchant = ({ getTotal }) => {
  const store = StoreHelper.generateStoreState(reducerSlice);

  const MainComponent = () => {
    const dispatch = useDispatch();

    const list = useSelector((state) => state.reducer.list);
    const loading = useSelector((state) => state.reducer.loading);
    const total = useSelector((state) => state.reducer.total);
    const totalPage = useSelector((state) => state.reducer.totalPage);
    const showDetail = useSelector((state) => state.reducer.showDetail);
    const fieldName = useSelector((state) => state.reducer.fieldName);
    const orderBy = useSelector((state) => state.reducer.orderBy);
    const currentPage = useSelector((state) => state.reducer.currentPage);
    const search = useSelector((state) => state.reducer.search);
    const postPerPage = useSelector((state) => state.reducer.postPerPage);

    const ShowDetail = () => {
      if (showDetail) {
        return <Detail getTotal={getTotal} />;
      } else {
        return <Total totalPosts={total} loading={loading} />;
      }
    };

    useEffect(() => {
      Action.getList(dispatch, {
        page: currentPage,
        search,
        postPerPage,
        fieldName,
        orderBy
      });
      getTotal();
    }, []);

    return (
      <div className="flex gap-x-3">
        <div className="basis-8/12">
          <div className="rounded-2xl p-5 bg-gray-primary">
            <div>
              <HeaderTabel />
            </div>
            <div className="my-2">
              <Tabel
                list={list}
                loading={loading}
                onClick={Action.changeShowDetail}
              />
            </div>
            <div>
              <Pagination
                totalPage={totalPage}
                postsPerPage={postPerPage}
                totalPosts={total}
                currentPage={currentPage}
                onClick={(page) => {
                  Action.getList(dispatch, {
                    page,
                    search,
                    postPerPage,
                    fieldName,
                    orderBy
                  });
                }}
              />
            </div>
          </div>
        </div>
        <div className=" basis-4/12 ">
          <div className="p-5 bg-gray-primary rounded-2xl h-auto">
            <ShowDetail />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Provider store={store}>
      <MainComponent />
    </Provider>
  );
};

export default RequestMerchant;
